import {obtenerIDLocal} from "./obtenerIDLocal";
import {doc, increment, setDoc, updateDoc} from "firebase/firestore";
import {fire} from "../../fire";

export const incrementarMetrica = async ({metrica, coleccion='metricas'}) => {

    let uid = obtenerIDLocal()

    let referencia = doc(fire, coleccion, uid)
    try {
        await updateDoc(referencia, {
            [metrica]: increment(1)
        });
    } catch (err) {

        try {
            await updateDoc(referencia, {[metrica]: 1});
        }catch(err) {
            await setDoc(referencia, {[metrica]: 1, id: uid});
        }

    }

}